import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { LeftFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const StyledIconWithLabel = styled(LeftFlexRow)`
    ${mixins.setFontVariant("chip1")};

    column-gap: 4px;
`;

export const StyledIcon = styled(SWReactIcons)`
    & svg path {
        fill: ${colorsPalettes.carbon["200"]};
        fill-opacity: 1;
    }
`;
